import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class DatosFacturaService {

     constructor(private http: HttpClient) {
    
    }

    registrar(datos_factura) {
      console.log("entramos en registrar")
      return this.http.patch<any>('https://vertigofin.herokuapp.com', { datos_factura })
        .pipe(map(confirmacion => {
       
            console.log("entramos en respuesta de datos factura")
            console.log(confirmacion)
            return confirmacion;
        }));
    }


}